import axios from "axios";
import { toast } from "react-toastify";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// -------------------- AXIOS Interceptor --------------------
// Handle unexpected error Globally:
axios.interceptors.response.use(/*success*/ null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status <= 500;

  if (!expectedError) {
    console.log("### INTERCEPTOR CALLED: ", error);
    toast.error("Slow Internet! Please reload the page");
    //toast.success("An unexpected error occurred.");
    return Promise.reject(error);
  }

  return Promise.reject(error);
});
// -------------------- AXIOS Interceptor --------------------

function setJwt(jwt) {
  axios.defaults.headers.common["x-auth-token"] = jwt;
  axios.defaults.headers.common["production"] = false;
  axios.defaults.headers.common["frontend"] = true;
}

function uploadFile(requestURL, bodyFormData, callback) {
  axios({
    method: "post",
    url: requestURL,
    data: bodyFormData,
    config: { headers: { "Content-Type": "multipart/form-data" } },
  })
    .then(function(response) {
      console.log("res", response);
      //handle success
      callback(null, response); // (err, result)
    })
    .catch(function(response) {
      console.log("err", response);
      //handle error
      callback(response, null); // (err, result)
    });
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  uploadFile: uploadFile,
  setJwt,
};



// WEBPACK FOOTER //
// ./src/services/APIServices.js